var _circle, _path, _path2;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F3F3F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8294B4",
    fillRule: "evenodd",
    d: "M6.533 19.51H9.39l2.52 11.568-3.15-1.589zm5.765 0h2.858l2.906 12.908-.339 1.49-2.519-1.241zm5.764 0h2.858L19.486 26z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0B2F69",
    fillRule: "evenodd",
    d: "M13.745 7h12.456L20 35l-2.316-1.108L20.92 19.51H6.533L6 17.028l15.502-.05.533-2.482-14.097-.05 1.889-2.432 12.789-.05.641-2.482H11.862l-.002.006zM28.235 9.582l1.89 2.482-4.506 20.206-2.76 1.34zm3.876 4.964L34 16.98l-2.761 12.51-2.713 1.34z",
    clipRule: "evenodd"
  })));
});
const SvgCin7Logo = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCin7Logo);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxjaXJjbGUgY3g9IjIwIiBjeT0iMjAiIHI9IjIwIiBmaWxsPSIjRjNGM0YzIi8+CiAgICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTYuNTMyOSAxOS41MTA2SDkuMzkxMDNMMTEuOTEwMSAzMS4wNzhMOC43NjEyNyAyOS40ODk0TDYuNTMyOSAxOS41MTA2Wk0xMi4yOTc2IDE5LjUxMDZIMTUuMTU1N0wxOC4wNjIzIDMyLjQxODRMMTcuNzIzMiAzMy45MDc4TDE1LjIwNDIgMzIuNjY2N0wxMi4yOTc2IDE5LjUxMDZaTTE4LjA2MjMgMTkuNTEwNkgyMC45MjA0TDE5LjQ4NjEgMjZMMTguMDYyMyAxOS41MTA2WiIgZmlsbD0iIzgyOTRCNCIvPgogICAgPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMy43NDU0IDdMMjYuMjAwNyA3TDIwIDM1TDE3LjY4NDMgMzMuODkxNkwyMC45MjA0IDE5LjUxMDZINi41MzI4N0w2IDE3LjAyODRMMjEuNTAxNyAxNi45Nzg3TDIyLjAzNDYgMTQuNDk2NUw3LjkzNzcyIDE0LjQ0NjhMOS44MjY5OSAxMi4wMTQyTDIyLjYxNTkgMTEuOTY0NUwyMy4yNTczIDkuNDgyMjdIMTEuODYxNkwxMS44NTk4IDkuNDg3NThMMTMuNzQ1NCA3WiIgZmlsbD0iIzBCMkY2OSIvPgogICAgPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yOC4yMzUzIDkuNTgxNTdMMzAuMTI0NiAxMi4wNjM4TDI1LjYxOTQgMzIuMjY5NUwyMi44NTgyIDMzLjYwOTlMMjguMjM1MyA5LjU4MTU3Wk0zMi4xMTA3IDE0LjU0NjFMMzQgMTYuOTc4N0wzMS4yMzg4IDI5LjQ4OTRMMjguNTI2IDMwLjgyOThMMzIuMTEwNyAxNC41NDYxWiIgZmlsbD0iIzBCMkY2OSIvPgo8L3N2Zz4K";